import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as ShareActions from './share.actions';
import { ShareButtonClickEventType, ShareDialogOpenEventType } from './share.models';

@Injectable()
export class ShareFacade {
  constructor(private readonly store: Store) {}

  click(shareButtonClickEvent: ShareButtonClickEventType) {
    this.store.dispatch(ShareActions.shareButtonClicked(shareButtonClickEvent));
  }

  open(shareDialogOpenEvent: ShareDialogOpenEventType) {
    this.store.dispatch(ShareActions.shareDialogOpened(shareDialogOpenEvent));
  }
}
